<template>
  <div class="layout">
    <!-- <photo v-if="templateName == '模板1'" :serial_number="serial_number" :templateName="templateName" :Status="Status" :equipment_model="equipment_model"/> -->
    <topology preview="true" :data="data" />
    <!-- <DefaultTemplate v-else :serial_number="serial_number"/> -->
  </div>
</template>

<script>
import DefaultTemplate from "@/components/template/default";
import DeviceTemplateService from "@/api/deviceTemplate";
import Vue from "vue";
import Topology from "topology-vue";
import "topology-vue/topology-vue.css";
Vue.use(Topology);
export default {
  components: {
    DefaultTemplate,
  },
  data() {
    return {
      status: "",
      pc: 1,
      timer: "",
      serial_number: "",
      templateName: "",
      equipment_model: "",
      data: {},
      user_id: this.$store.state.user_id,
      code: "", //随机6位字符串
    };
  },
  methods: {
    getTemplate() {
      let _this = this;
      DeviceTemplateService.getTemplate({
        user_id: this.user_id,
        templateName: this.templateName,
        parentPageModel: this.equipment_model,
        status: this.status,
      })
        .then((res) => {
          if (this.pc == 1) {
            this.$set(res.data, "locked", 2);
          } else {
            this.$set(res.data, "locked", 1);
          }
          this.data = res.data;
          this.$set(this.data, "mqttTopics", `update/${this.serial_number}`);
          setTimeout(() => {
            window.topology.fitView();
            window.topology.options.disableScale = true;
            this.$set(
              window.topology.data.mqttOptions,
              "clientId",
              `WS${this.serial_number}-${this.code}`
            );
            this.$set(
              window.topology.data.mqttOptions,
              "username",
              "yunliansuperuser"
            );
            this.$set(window.topology.data.mqttOptions, "password", "public");
            let pen = window.topology.find("data");
            if (pen) {
              if (typeof pen == "object") {
                pen.serial_number = _this.serial_number;
              } else {
                pen.forEach((e) => {
                  e.serial_number = _this.serial_number;
                });
              }
            }
            window.topology.openMqtt(this.$wssURL);
          }, 100);
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
  },
  created() {
    let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    let maxPos = chars.length;
    for (let i = 0; i < 6; i++) {
      this.code += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    window.topology.closeMqtt();
    this.templateName = "";
    if (this.$route.query) {
      //  console.log(this.$route.query.templateName.substring(5,7))
      document.title = this.$route.query.templateName.substring(5, 7) + "组态";
      this.serial_number = this.$route.query.serial_number;
      this.templateName = this.$route.query.templateName;
      this.equipment_model = this.$route.query.equipment_model;
      if (this.$route.query.user_id) {
        this.user_id = this.$route.query.user_id;
        this.pc = 0;
      }
    } else {
      this.serial_number = sessionStorage.getItem("serial_number");
    }
    if (window.registerTools) {
      window.registerTools();
    }
    var ua = navigator.userAgent.toLowerCase();

    if (ua.indexOf("mobi") != -1) {
      // 手机浏览器
      window.sessionStorage.setItem("user_id", this.user_id);
    } else {
      // 非手机浏览器
    }
  },
  mounted() {
    window.addEventListener("resize", function() {
      window.topology.fitView(16);
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        if (this.$route.query.templateName) {
          document.title =
            this.$route.query.templateName.substring(5, 7) + "组态";
          this.serial_number = this.$route.query.serial_number;
          this.templateName = this.$route.query.templateName;
          this.equipment_model = this.$route.query.equipment_model;
          this.status = this.$route.query.status;
          if (this.$route.query.user_id) {
            this.user_id = this.$route.query.user_id;
            this.pc = 0;
          }
          this.getTemplate();
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.layout {
  height: 100vh;
}
</style>
